// extracted by mini-css-extract-plugin
export default {"title":"Dnineth_title__pzoHd","desc":"Dnineth_desc__lCCbe","text":"Dnineth_text__a9MtW","Dnineth":"Dnineth_Dnineth__hFI3N"};